import { useState, memo } from 'react'
import { Image, IconFilledPlayFat, IconYoutube } from '@tracklib/kit'
import VideoModal from 'components/modal/video'
import styles from './video.css'

type VideoProps = {
  title: string
  owner: string
  length: string
  image: number
  src: string
  className: string
}

const Video = ({ title, owner, length, image, src, className }: VideoProps): JSX.Element => {
  const [modalIsOpen, setModalOpen] = useState(false)

  return (
    <article className={[className, styles.video].join(' ')}>
      <button className={styles.button} onClick={() => setModalOpen(true)}>
        <IconFilledPlayFat className={styles.playButton} />
        <Image image={image} alt={title} gradient absolute sizes="(min-width: 769px) 66vw, 100vw" />
        <div className={styles.info}>
          <div className={styles.extras}>
            {owner && (
              <span className={styles.owner}>
                By {owner}
                <em>•</em>
              </span>
            )}
            {length && <span className={styles.length}>{length}</span>}
            {(owner || length) && <IconYoutube className={styles.youtubeIcon} />}
          </div>
          <h2 className={styles.title}>{title}</h2>
        </div>
      </button>
      <VideoModal videoUrl={src} isOpen={modalIsOpen} closeModal={() => setModalOpen(false)} />
    </article>
  )
}

export default memo<VideoProps>(Video)
